import { useEffect, useCallback, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "app/hooks"
import {
  getBody,
  getBodyDisplayUnits,
  incrementRefreshCount,
} from "features/profile/profileSlice"
import { getUserPlan } from "features/payment/paymentSlice"
import { getGoal } from "features/onboarding/onboardingSlice"
import PATHS from "router/paths"

const GET_GOAL_PATHS = [PATHS.app.root, PATHS.app.yourGoal.root]

const GET_USER_PLAN_PATHS = [
  PATHS.app.root,
  PATHS.app.barcodeScanner.root,
  PATHS.app.meal.scan,
]

const RESET_PATHS = [
  PATHS.app.yourGoal.updateBodyAndGoal,
  PATHS.app.setGoal,
  PATHS.app.personalInfo,
]

const REFRESH_THROTTLE_MS = 1000

export const useFoodJournalDataRefresh = () => {
  const dispatch = useAppDispatch()
  const token = useAppSelector((state) => state.auth.token)
  const { pathname } = useLocation()
  const pathnameRef = useRef(pathname)
  const lastRefreshRef = useRef(0)

  useEffect(() => {
    pathnameRef.current = pathname
  }, [pathname])

  const refreshData = useCallback(() => {
    if (!token) return

    const now = Date.now()
    if (now - lastRefreshRef.current < REFRESH_THROTTLE_MS) return
    lastRefreshRef.current = now

    const path = pathnameRef.current

    if (GET_GOAL_PATHS.includes(path)) dispatch(getGoal(false))
    if (GET_USER_PLAN_PATHS.includes(path)) dispatch(getUserPlan())
    if (RESET_PATHS.includes(path)) dispatch(incrementRefreshCount())

    dispatch(getBodyDisplayUnits())
  }, [token])

  useEffect(() => {
    ;(window as any).refreshFoodJournalData = refreshData
  }, [refreshData])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshData()
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange)
  }, [refreshData])
}
